<template>
  <v-card v-if="warnings.length" color="grey darken-3" class="max-auto mb-6" tile>
    <v-list v-for="(warningBlock, index) in warnings" :key="index" two-line color="secondary pb-0" :color="warningBlock.color" style="border-radius:0;">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title v-if="warningBlock.message">{{ warningBlock.message }}</v-list-item-title>
        </v-list-item-content>

        <v-list-item-avatar v-if="warningBlock.icon">
          <v-icon>{{ warningBlock.icon }} </v-icon>
        </v-list-item-avatar>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script setup>
import { computed } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
  contentTypeWarnings: { type: Object, required: true },
  content: { type: Object, required: true }
});

const warnings = computed(() => {
  const warningsArray = [];
  Object.entries(props.contentTypeWarnings).forEach(([key, configs]) => {
    if (props.content && props.content[key] && configs.fields) {
      const warning = {};
      configs.fields.forEach(c => { warning[c] = props.content[key][c]; });

      warningsArray.push(warning);
    }
  });

  return warningsArray;
});

</script>

<!-- <script>

export default {
  props: {
    contentTypeWarnings: Object,
    content: Object

  },
  computed: {
    warnings () {
      const warnings = [];
      Object.entries(this.contentTypeWarnings).forEach(([key, configs]) => {
        if (this.content && this.content[key] && configs.fields) {
          const warning = {};
          configs.fields.forEach(c => { warning[c] = this.content[key][c]; });

          warnings.push(warning);
        }
      });

      return warnings;
    }
  }
};
</script> -->
